import { LitElement, html, css } from '~/lib/bn-lit-element';

import { sharedStyles } from '../styles/shared-styles';

class BnProperty extends LitElement {
  static get properties() {
    return {
      label: { type: String },
      value: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        line-height: 1.5em;
        display: flex;
        align-items: flex-start;
        padding: .5em 0;
      }
      :host([stacked]) {
        line-height: inherit;
        flex-direction: column;
        align-items: baseline;
        white-space: nowrap;
        padding: 0;
      }
      label {
        margin-right: .5em;
        color: var(--bn-property-label-color, var(--gray-80));
      }
      :host([stacked]) label {
        font-size: .75em;
        margin-right: .25em;
      }
      :host([emphasized]) .value {
        font-weight: bold;
      }
      :host([overflow-ellipsis]) .value {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      label:after {
        content: ':';
      }
      :host([stacked]) label:after {
        content: none;
      }
      .value {
        text-align: var(--align-value, left);
        flex-grow: 1;
      }
      :host([stacked]) .value {
        width: 100%;
      }
    `];
  }

  render() {
    return html`
      <label>${this.label}</label>
      <span class="value">
        <slot>${this.value}</slot>
      </span>
    `;
  }
}

window.customElements.define('bn-property', BnProperty);
